import React, { FC } from "react";
import { ComingNomenclatureFareBalance } from "bus/comingNomenclatureMain/types";

type Props = Omit<ComingNomenclatureFareBalance, 'data'> & {
    dateBegin: string;
    dateEnd: string;
};

const ComingNomenclatureFareInfo: FC<Props> = ({
	adjustments,
    balance,
    pay,
    toPay,
    dateBegin,
    outBalance,
    dateEnd
}) => {
	return (
		<div className="d-flex mt-2">
			<div className="dx-card pl-2 pr-2 pb-2 mb-3 mr-2" style={{ width: 450 }}>
				<div className="info">
					<div className="info__title">Остаток на начало периода</div>
					<div className="info__child">{balance}</div>
				</div>
				<div className="info">
					<div className="info__title">Остаток на конец периода</div>
					<div className="info__child">{outBalance}</div>
				</div>
			</div>
		</div>
	);
};

export default ComingNomenclatureFareInfo;
